export default "__VITE_ASSET__DYwyyQnb__"